// API paths - originally generated, manually maintained
export var API_PATHS = {
    /**
     * Path: /legal-deposits/publishers
     * GET: No description
     * Response: PublisherCollectionResponse
     * POST: No description
     * Request: PublisherCreate
     * Response: Publisher
     */
    LEGAL_DEPOSITS_PUBLISHERS: "legal-deposits/publishers",
    /**
     * Path: /legal-deposits/titles/pending-verification
     * GET: Tituly čekající na ověření příjmu
     * Response: object
     */
    LEGAL_DEPOSITS_TITLES_PENDING_VERIFICATION: "legal-deposits/titles/pending-verification",
    /**
     * Path: /legal-deposits/periodicals/pending-verification
     * GET: Periodika čekající na ověření
     * Response: object
     */
    LEGAL_DEPOSITS_PERIODICALS_PENDING_VERIFICATION: "legal-deposits/periodicals/pending-verification",
    /**
     * Path: /legal-deposits/periodicals/frequency-conflicts
     * GET: Periodika s konfliktem periodicity (SKC vs ReČeK)
     * Response: object
     */
    LEGAL_DEPOSITS_PERIODICALS_FREQUENCY_CONFLICTS: "legal-deposits/periodicals/frequency-conflicts",
    /**
     * Path: /legal-deposits/titles/needs-publisher
     * GET: Tituly čekající na párování nakladatele
     * Response: object
     */
    LEGAL_DEPOSITS_TITLES_NEEDS_PUBLISHER: "legal-deposits/titles/needs-publisher",
    /**
     * Path: /legal-deposits/receipts/bulk-confirm
     * POST: Hromadné potvrzení příjmu
     * Request: object
     * Response: object
     */
    LEGAL_DEPOSITS_RECEIPTS_BULK_CONFIRM: "legal-deposits/receipts/bulk-confirm",
    /**
     * Path: /legal-deposits/receipts/scan
     * POST: Skenování ISBN pro příjem
     * Request: object
     * Response: object
     */
    LEGAL_DEPOSITS_RECEIPTS_SCAN: "legal-deposits/receipts/scan",
    /**
     * Path: /legal-deposits/titles/enforcements
     * GET: Seznam vymáhání
     * Response: object
     * POST: Vytvoření vymáhání
     * Request: EnforcementCreate
     * Response: Enforcement
     */
    LEGAL_DEPOSITS_ENFORCEMENTS: "legal-deposits/titles/enforcements",
    /**
     * Path: /legal-deposits/regions
     * GET: No description
     * Response: CollectionResponseRegionDto
     */
    LEGAL_DEPOSITS_REGIONS: "legal-deposits/regions",
    /**
     * Path: /legal-deposits/users
     * GET: No description
     * Response: CollectionResponseUserDto
     */
    LEGAL_DEPOSITS_USERS: "legal-deposits/users",
    /**
     * Path: /legal-deposits/libraries
     * GET: No description
     * Response: CollectionResponseLibraryDto
     * POST: Create a new library
     * Request: LibraryCreateDto
     * Response: LibraryDto
     */
    LEGAL_DEPOSITS_LIBRARIES: "legal-deposits/libraries",
    REPORTS_KULT_15_01: "legal-deposits/reports/kult-15-01",
    REPORTS_KULT_15_01_EXPORT: "legal-deposits/reports/kult-15-01/export",
    REPORTS_KULT_05_01: "legal-deposits/reports/kult-05-01",
    REPORTS_KULT_05_01_EXPORT: "legal-deposits/reports/kult-05-01/export",
    REPORTS_KULT_05_01_SUBJECT_GROUPS: "legal-deposits/reports/kult-05-01/subject-groups",
    /**
     * Path: /legal-deposits/system/sync/titles
     * POST: Manuální synchronizace titulů
     * Response: object
     */
    LEGAL_DEPOSITS_SYSTEM_SYNC_TITLES: "legal-deposits/system/sync/titles",
    /**
     * Path: /legal-deposits/system/reminders/send
     * POST: Manuální odeslání připomínek
     * Response: object
     */
    LEGAL_DEPOSITS_SYSTEM_REMINDERS_SEND: "legal-deposits/system/reminders/send",
    /**
     * Path: /legal-deposits/inbox
     * POST: No description
     * Request: InboxEventDto
     * Response: void
     */
    LEGAL_DEPOSITS_INBOX: "legal-deposits/inbox",
    /**
     * Path: /_/tenant
     * POST: Create tenant job (create, upgrade, delete)
     * Request: tenantAttributes
     * Response: void
     */
    TENANT: "_/tenant",
    /**
     * Path: /legal-deposits/process-outbox
     * GET: No description
     * Response: void
     */
    LEGAL_DEPOSITS_PROCESS_OUTBOX: "legal-deposits/process-outbox",
    /**
     * Path: /legal-deposits/admin/harvest-skc-bulk
     * POST: Trigger bulk SKC harvest
     * Request: { from: string }
     * Response: 202 + { runId: string }, 409 if already running
     */
    LEGAL_DEPOSITS_HARVEST_SKC_BULK: "legal-deposits/admin/harvest-skc-bulk",
    /**
     * Path: /legal-deposits/admin/harvest-skc-status
     * GET: Last SKC harvest run status
     * Response: 200 + HarvestStatusDto, 204 if no run exists
     */
    LEGAL_DEPOSITS_HARVEST_SKC_STATUS: "legal-deposits/admin/harvest-skc-status",
    LEGAL_DEPOSITS_HARVEST_SKC_STOP: "legal-deposits/admin/harvest-skc-stop",
    LEGAL_DEPOSITS_HARVEST_SKC_RETRY_FAILED: "legal-deposits/admin/harvest-skc-retry-failed",
    LEGAL_DEPOSITS_HARVEST_SKC_RETRY_FAILED_STATUS: "legal-deposits/admin/harvest-skc-retry-failed/status",
    LEGAL_DEPOSITS_ADMIN_BACKFILL: "legal-deposits/admin/backfill-deposit-records",
    LEGAL_DEPOSITS_ADMIN_BACKFILL_STATUS: "legal-deposits/admin/backfill-deposit-records/status",
    LEGAL_DEPOSITS_ADMIN_DETECT_OVERDUE: "legal-deposits/admin/detect-overdue",
    LEGAL_DEPOSITS_ADMIN_DETECT_OVERDUE_STATUS: "legal-deposits/admin/detect-overdue/status",
    LEGAL_DEPOSITS_ADMIN_HARVEST_LIBRARIES_STATUS: "legal-deposits/admin/harvest-libraries/status",
    LEGAL_DEPOSITS_ADMIN_HARVEST_LIBRARIES: "legal-deposits/admin/harvest-libraries",
    LEGAL_DEPOSITS_ADMIN_REALIGN_SCHEDULES: "legal-deposits/admin/realign-schedules",
    LEGAL_DEPOSITS_TITLES_REQUESTABLE: "legal-deposits/titles/requestable",
    LEGAL_DEPOSITS_TITLES_WITH_ISBN: "legal-deposits/titles/with-isbn",
    LEGAL_DEPOSITS_TITLES_SUGGEST: "legal-deposits/titles/suggest",
    LEGAL_DEPOSITS_TITLES_WITHOUT_ISBN: "legal-deposits/titles/without-isbn",
    LEGAL_DEPOSITS_CROSS_LIBRARY: "legal-deposits/cross-library",
    LEGAL_DEPOSITS_DEPOSIT_RECORDS: "legal-deposits/deposit-records",
    LEGAL_DEPOSITS_DEPOSIT_RECORDS_AGENCY_TITLE_DETAIL: "legal-deposits/deposit-records/agency-title-detail",
    LEGAL_DEPOSITS_DEPOSIT_RECORDS_RECEIVE_BY_ISBN: "legal-deposits/deposit-records/receive-by-isbn",
    LEGAL_DEPOSITS_DEPOSIT_RECORDS_CONFIRM_AGENCY_TITLE: "legal-deposits/deposit-records/confirm-agency-title",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE: "legal-deposits/titles/enforcements/urgence",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_PREVIEW: "legal-deposits/titles/enforcements/urgence/preview",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_TITLES: "legal-deposits/titles/enforcements/urgence-by-titles",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_TITLES_PREVIEW: "legal-deposits/titles/enforcements/urgence-by-titles/preview",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_PUBLISHER: "legal-deposits/titles/enforcements/urgence-by-publisher",
    LEGAL_DEPOSITS_ENFORCEMENTS_URGENCE_BY_PUBLISHER_PREVIEW: "legal-deposits/titles/enforcements/urgence-by-publisher/preview",
    LEGAL_DEPOSITS_ENFORCEMENTS_DAMAGED_CLAIM: "legal-deposits/titles/enforcements/damaged-claim",
    LEGAL_DEPOSITS_ENFORCEMENTS_DAMAGED_CLAIM_PREVIEW: "legal-deposits/titles/enforcements/damaged-claim/preview",
    LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION: "legal-deposits/titles/enforcements/pre-litigation",
    LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION_PREVIEW: "legal-deposits/titles/enforcements/pre-litigation/preview",
    LEGAL_DEPOSITS_ENFORCEMENTS_PRE_LITIGATION_REPORT: "legal-deposits/titles/enforcements/pre-litigation/report",
    LEGAL_DEPOSITS_TITLES_EXCLUDE_BY_TITLES: "legal-deposits/titles/exclude-by-titles",
    LEGAL_DEPOSITS_TITLES_EXCLUDE_BY_TITLES_PREVIEW: "legal-deposits/titles/exclude-by-titles/preview",
    LEGAL_DEPOSITS_TITLES_DAMAGED_CLAIM_BY_TITLES_PREVIEW: "legal-deposits/titles/damaged-claim-by-titles/preview",
    LEGAL_DEPOSITS_TITLES_DAMAGED_CLAIM_BY_TITLES: "legal-deposits/titles/damaged-claim-by-titles",
    LEGAL_DEPOSITS_TITLES_REQUEST_COPY_BY_TITLES_PREVIEW: "legal-deposits/titles/request-copy-by-titles/preview",
    LEGAL_DEPOSITS_TITLES_REQUEST_COPY_BY_TITLES: "legal-deposits/titles/request-copy-by-titles",
    LEGAL_DEPOSITS_PERIODICAL_CHECK_TASKS: "legal-deposits/periodical-check-tasks",
    LEGAL_DEPOSITS_PERIODICAL_CHECK_TASKS_COUNT: "legal-deposits/periodical-check-tasks/count",
    LEGAL_DEPOSITS_PERIODICAL_LIBRARIES: "legal-deposits/periodical-libraries",
    LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_SUBSCRIBE_BY_IDS: "legal-deposits/periodical-libraries/subscribe-by-ids",
    LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_EXCLUDE_BY_IDS: "legal-deposits/periodical-libraries/exclude-by-ids",
    LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_EXCLUDE_BY_TITLES: "legal-deposits/periodical-libraries/exclude-by-titles",
    LEGAL_DEPOSITS_TITLES_VERIFY_BY_TITLES: "legal-deposits/titles/verify-by-titles",
    LEGAL_DEPOSITS_TITLES_START_INVESTIGATION_BY_TITLES: "legal-deposits/titles/start-investigation-by-titles",
    LEGAL_DEPOSITS_TITLES_LIBRARY_NOTE_BY_TITLES: "legal-deposits/titles/library-note-by-titles",
    LEGAL_DEPOSITS_TITLES_PROVISIONAL: "legal-deposits/titles/provisional",
    LEGAL_DEPOSITS_TITLES_MERGE: "legal-deposits/titles/merge",
    LEGAL_DEPOSITS_TITLES_MERGE_PREVIEW: "legal-deposits/titles/merge/preview",
    LEGAL_DEPOSITS_TITLES_MERGE_CANDIDATES: "legal-deposits/titles/merge-candidates",
    LEGAL_DEPOSITS_TITLES_COMPARE: "legal-deposits/titles/compare",
    LEGAL_DEPOSITS_TITLES_DUPLICATE_REVIEWS: "legal-deposits/titles/duplicate-reviews",
};
// Parameterized path functions
/**
 * Path: /legal-deposits/publishers/{id}
 * GET: No description
 * Response: Publisher
 * PUT: No description
 * Request: PublisherUpdate
 * Response: Publisher
 */
export var legalDepositsPublishersId = function (id) {
    return "legal-deposits/publishers/".concat(id);
};
/**
 * Path: /legal-deposits/publishers/{id}/local-contacts
 * PUT: No description
 * Request: PublisherLocalContactsUpdate
 * Response: Publisher
 */
export var legalDepositsPublishersIdLocalContacts = function (id) {
    return "legal-deposits/publishers/".concat(id, "/local-contacts");
};
export var legalDepositsPublishersIdReminderSettings = function (id) { return "legal-deposits/publishers/".concat(id, "/reminder-settings"); };
/**
 * Path: /legal-deposits/titles/{id}
 * GET: Detail titulu
 * Response: TitleDetail
 */
export var legalDepositsTitlesId = function (id) {
    return "legal-deposits/titles/".concat(id);
};
export var legalDepositsPeriodicalsTitlesId = function (id) {
    return "legal-deposits/periodicals/titles/".concat(id);
};
export var legalDepositsTitlesSearchId = function (id) {
    return "legal-deposits/titles/search/".concat(id);
};
/**
 * Path: /legal-deposits/titles/{id}/pair-publisher
 * POST: Napárování nakladatele k titulu
 * Request: object
 * Response: Title
 */
export var legalDepositsTitlesIdPairPublisher = function (id) {
    return "legal-deposits/titles/".concat(id, "/pair-publisher");
};
/**
 * Path: /legal-deposits/titles/{id}/reject
 * POST: Zamítnutí titulu
 * Request: object
 * Response: void
 */
export var legalDepositsTitlesIdReject = function (id) {
    return "legal-deposits/titles/".concat(id, "/reject");
};
export var legalDepositsTitlesIdStartInvestigation = function (id) {
    return "legal-deposits/titles/".concat(id, "/start-investigation");
};
export var legalDepositsTitlesIdResolveInvestigation = function (id) { return "legal-deposits/titles/".concat(id, "/resolve-investigation"); };
export var legalDepositsTitlesIdInvestigationNotes = function (id) {
    return "legal-deposits/titles/".concat(id, "/investigation-notes");
};
/**
 * Path: /legal-deposits/titles/{id}/distribution
 * GET: Distribuce titulu do knihoven
 * Response: object
 */
export var legalDepositsTitlesIdDistribution = function (id) {
    return "legal-deposits/titles/".concat(id, "/distribution");
};
/**
 * Path: /legal-deposits/titles/{id}/enforcement-history
 * GET: Historie vymáhání titulu
 * Response: object
 */
export var legalDepositsTitlesIdEnforcementHistory = function (id) {
    return "legal-deposits/titles/".concat(id, "/enforcement-history");
};
export var legalDepositsDepositRecordsIdTimeline = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/timeline");
};
export var legalDepositsTitlesIdExclude = function (id) {
    return "legal-deposits/titles/".concat(id, "/exclude");
};
export var legalDepositsTitlesIdReinstate = function (id) {
    return "legal-deposits/titles/".concat(id, "/reinstate");
};
export var legalDepositsTitlesReinstateByTitles = "legal-deposits/titles/reinstate-by-titles";
export var legalDepositsTitleProvisionalId = function (id) {
    return "legal-deposits/titles/".concat(id, "/provisional");
};
/**
 * Path: /legal-deposits/titles/{provisionalId}/merge-with/{realId}
 * POST: Sloučení provizorního titulu s reálným
 * Response: Title
 */
export var legalDepositsTitlesIdMergeWith = function (provisionalId, realId) { return "legal-deposits/titles/".concat(provisionalId, "/merge-with/").concat(realId); };
/**
 * Path: /legal-deposits/titles/{provisionalId}/merge-candidates
 * GET: Reálné tituly, se kterými lze provizorní záznam sloučit
 * Response: TitleSearchCollectionResponse
 */
export var legalDepositsTitlesIdMergeCandidates = function (provisionalId) { return "legal-deposits/titles/".concat(provisionalId, "/merge-candidates"); };
/**
 * Path: /legal-deposits/titles/{id}/force
 * DELETE: Vynucené smazání provizorního titulu i s navázanou evidencí
 */
export var legalDepositsTitlesIdForce = function (id) {
    return "legal-deposits/titles/".concat(id, "/force");
};
/**
 * Path: /legal-deposits/periodicals/{id}
 * GET: Detail periodika
 * Response: Periodical
 * PATCH: Změna statusu periodika
 * Request: object
 * Response: Periodical
 */
export var legalDepositsPeriodicalsId = function (id) {
    return "legal-deposits/periodicals/".concat(id);
};
export var legalDepositsPeriodicalsIdCheckSettings = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/check-settings");
};
export var legalDepositsPeriodicalsIdContinuousNumbering = function (id) { return "legal-deposits/periodicals/".concat(id, "/continuous-numbering"); };
export var legalDepositsPeriodicalsIdContinuousNumberingPreview = function (id) { return "legal-deposits/periodicals/".concat(id, "/continuous-numbering/preview"); };
export var legalDepositsPeriodicalsIdNextIssueNumber = function (id) { return "legal-deposits/periodicals/".concat(id, "/next-issue-number"); };
export var legalDepositsPeriodicalCheckTasksIdInquiryPreview = function (id) { return "legal-deposits/periodical-check-tasks/".concat(id, "/inquiry-preview"); };
export var legalDepositsPeriodicalCheckTasksIdInquiry = function (id) { return "legal-deposits/periodical-check-tasks/".concat(id, "/inquiry"); };
export var legalDepositsPeriodicalCheckTasksIdPostpone = function (id) { return "legal-deposits/periodical-check-tasks/".concat(id, "/postpone"); };
export var legalDepositsPeriodicalCheckTasksIdClose = function (id) {
    return "legal-deposits/periodical-check-tasks/".concat(id, "/close");
};
export var legalDepositsPeriodicalCheckTasksIdCommunications = function (id) { return "legal-deposits/periodical-check-tasks/".concat(id, "/communications"); };
/**
 * Path: /legal-deposits/periodicals/{id}/issues
 * GET: Čísla periodika
 * Response: object
 */
export var legalDepositsPeriodicalsIdIssues = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/issues");
};
/**
 * Path: /legal-deposits/periodicals/{id}/first-issue/confirm
 * POST: Potvrzení příjmu prvního čísla NOVÉHO periodika
 * Request: object
 * Response: void
 */
export var legalDepositsPeriodicalsIdFirstIssueConfirm = function (id) { return "legal-deposits/periodicals/".concat(id, "/first-issue/confirm"); };
/**
 * Path: /legal-deposits/periodicals/{id}/issues/{issueId}/mark-missing
 * PATCH: Označení čísla jako chybějícího
 * Request: object
 * Response: void
 */
export var legalDepositsPeriodicalsIdIssuesIssueidMarkMissing = function (id, issueId) { return "legal-deposits/periodicals/".concat(id, "/issues/").concat(issueId, "/mark-missing"); };
/**
 * Path: /legal-deposits/periodicals/{id}/issues/{issueId}/mark-not-published
 * PATCH: Označení čísla jako nevydaného
 * Request: object
 * Response: void
 */
export var legalDepositsPeriodicalsIdIssuesIssueidMarkNotPublished = function (id, issueId) { return "legal-deposits/periodicals/".concat(id, "/issues/").concat(issueId, "/mark-not-published"); };
/**
 * Path: /legal-deposits/periodicals/{id}/frequency
 * PATCH: Změna periodicity periodika
 * Request: object
 * Response: void
 */
export var legalDepositsPeriodicalsIdFrequency = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/frequency");
};
export var legalDepositsPeriodicalsIdKultSubjectGroup = function (id) { return "legal-deposits/periodicals/".concat(id, "/kult-subject-group"); };
/**
 * Path: /legal-deposits/periodicals/{id}/accept-skc
 * PATCH: Přijmout SKC periodicitu (vyřešit konflikt ve prospěch SKC)
 * Response: void
 */
export var legalDepositsPeriodicalsIdAcceptSkc = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/accept-skc");
};
/**
 * Path: /legal-deposits/periodicals/{id}/keep-recek
 * PATCH: Ponechat ReČeK periodicitu (potvrdit odchylku od SKC)
 * Response: void
 */
export var legalDepositsPeriodicalsIdKeepRecek = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/keep-recek");
};
/**
 * Path: /legal-deposits/periodicals/{id}/special-issues
 * GET: Seznam speciálních čísel čekajících na potvrzení
 * Response: object
 * POST: Vytvoření/oznámení speciálního čísla periodika
 * Request: object
 * Response: object
 */
export var legalDepositsPeriodicalsIdSpecialIssues = function (id) {
    return "legal-deposits/periodicals/".concat(id, "/special-issues");
};
/**
 * Path: /legal-deposits/periodicals/{id}/special-issues/{issueId}/confirm
 * POST: Potvrzení příjmu speciálního čísla
 * Request: object
 * Response: object
 */
export var legalDepositsPeriodicalsIdSpecialIssuesIssueidConfirm = function (id, issueId) { return "legal-deposits/periodicals/".concat(id, "/special-issues/").concat(issueId, "/confirm"); };
/**
 * Path: /legal-deposits/titles/enforcements/{id}
 * GET: Detail vymáhání
 * Response: Enforcement
 */
export var legalDepositsEnforcementsId = function (id) {
    return "legal-deposits/titles/enforcements/".concat(id);
};
/**
 * Path: /legal-deposits/titles/enforcements/{id}/send
 * POST: Odeslání urgence
 * Request: object
 * Response: object
 */
export var legalDepositsEnforcementsIdSend = function (id) {
    return "legal-deposits/titles/enforcements/".concat(id, "/send");
};
/**
 * Path: /legal-deposits/titles/enforcements/{id}/communications
 * POST: Přidání komunikace k vymáhání
 * Request: object
 * Response: void
 */
export var legalDepositsEnforcementsIdCommunications = function (id) { return "legal-deposits/titles/enforcements/".concat(id, "/communications"); };
/**
 * Path: /legal-deposits/titles/enforcements/{id}/mark-delivered
 * PATCH: Označení titulu jako doručeného
 * Request: object
 * Response: object
 */
export var legalDepositsEnforcementsIdMarkDelivered = function (id) {
    return "legal-deposits/titles/enforcements/".concat(id, "/mark-delivered");
};
/**
 * Path: /legal-deposits/titles/enforcements/{id}/escalate
 * POST: Eskalace vymáhání
 * Request: object
 * Response: void
 */
export var legalDepositsEnforcementsIdEscalate = function (id) {
    return "legal-deposits/titles/enforcements/".concat(id, "/escalate");
};
/**
 * Path: /legal-deposits/titles/enforcements/{id}/timeline
 * GET: Timeline komunikace vymáhání
 * Response: object
 */
export var legalDepositsEnforcementsIdTimeline = function (id) {
    return "legal-deposits/titles/enforcements/".concat(id, "/timeline");
};
/**
 * Path: /legal-deposits/users/{id}
 * GET: No description
 * Response: UserDto
 * PATCH: No description
 * Request: UserUpdateDto
 * Response: UserDto
 */
export var legalDepositsUsersId = function (id) {
    return "legal-deposits/users/".concat(id);
};
/**
 * Path: /legal-deposits/users/{userId}/libraries/{libraryId}
 * PATCH: No description
 * Request: UserLibraryUpdateDto
 * Response: UserLibraryDto
 */
export var legalDepositsUsersUseridLibrariesLibraryid = function (userId, libraryId) { return "legal-deposits/users/".concat(userId, "/libraries/").concat(libraryId); };
/**
 * Path: /legal-deposits/libraries/{id}
 * GET: No description
 * Response: LibraryDto
 * PUT: Update an existing library
 * Request: LibraryUpdateDto
 * Response: LibraryDto
 * DELETE: No description
 * Response: void
 */
export var legalDepositsLibrariesId = function (id) {
    return "legal-deposits/libraries/".concat(id);
};
/**
 * Path: /legal-deposits/libraries/{id}/delete-preview
 * GET: Preview which users will lose access when the library is soft-deleted
 * Response: LibraryDeletePreviewDto
 */
export var legalDepositsLibrariesIdDeletePreview = function (id) {
    return "legal-deposits/libraries/".concat(id, "/delete-preview");
};
/**
 * Path: /legal-deposits/publishers/{id}/prefix-history
 * GET: No description
 * Response: PublisherPrefixHistoryCollectionResponse
 */
export var legalDepositsPublishersIdPrefixHistory = function (id) {
    return "legal-deposits/publishers/".concat(id, "/prefix-history");
};
/**
 * Path: /_/tenant/{operationId}
 * GET: Does tenant id already exist
 * Response: string
 * DELETE: drop tenant id
 * Response: void
 */
export var tenantOperationid = function (operationId) {
    return "_/tenant/".concat(operationId);
};
export var legalDepositsHarvestSkcResume = function (runId) {
    return "legal-deposits/admin/harvest-skc-resume/".concat(runId);
};
export var legalDepositsAdminHarvestLibrary = function (libraryId) {
    return "legal-deposits/admin/harvest-library/".concat(libraryId);
};
export var legalDepositsDepositRecordsByTitle = function (titleId) {
    return "legal-deposits/deposit-records/by-title/".concat(titleId);
};
export var legalDepositsDepositRecordsIdReceive = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/receive");
};
export var legalDepositsDepositRecordsIdExclude = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/exclude");
};
export var legalDepositsDepositRecordsIdReinstate = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/reinstate");
};
export var legalDepositsDepositRecordsIdReportDamaged = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/report-damaged");
};
export var legalDepositsDepositRecordsIdStatus = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/status");
};
export var legalDepositsDepositRecordsIdReminderStatus = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/reminder-status");
};
export var legalDepositsDepositRecordsIdDamagedClaim = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/damaged-claim");
};
export var legalDepositsDepositRecordsIdDamagedClaimPreview = function (id) {
    return "legal-deposits/deposit-records/".concat(id, "/damaged-claim/preview");
};
export var legalDepositsTitlesIdExtraCopy = function (id) {
    return "legal-deposits/titles/".concat(id, "/extra-copy");
};
export var legalDepositsTitlesIdExtraCopyReceive = function (id) {
    return "legal-deposits/titles/".concat(id, "/extra-copy/receive");
};
export var legalDepositsTitlesIdRequestCopy = function (id) {
    return "legal-deposits/titles/".concat(id, "/request-copy");
};
export var legalDepositsTitlesIdRequestCopyPreview = function (id) {
    return "legal-deposits/titles/".concat(id, "/request-copy/preview");
};
export var legalDepositsPublishersLookup = function (companyNumber) {
    return "legal-deposits/publishers/".concat(companyNumber, "/lookup");
};
export var legalDepositsPublishersCheckDuplicity = function (companyNumber) {
    return "legal-deposits/publishers/".concat(companyNumber, "/checkDuplicity");
};
export var legalDepositsPeriodicalLibrariesId = function (id) {
    return "legal-deposits/periodical-libraries/".concat(id);
};
export var legalDepositsPeriodicalLibrariesIdStatus = function (id) {
    return "legal-deposits/periodical-libraries/".concat(id, "/status");
};
export var legalDepositsPeriodicalLibrariesIdVolumes = function (plId) {
    return "legal-deposits/periodical-libraries/".concat(plId, "/volumes");
};
export var legalDepositsPeriodicalLibrariesIdVolumesIdIssues = function (plId, volumeId) { return "legal-deposits/periodical-libraries/".concat(plId, "/volumes/").concat(volumeId, "/issues"); };
export var legalDepositsPeriodicalLibrariesIdVolumesNext = function (plId) {
    return "legal-deposits/periodical-libraries/".concat(plId, "/volumes/next");
};
export var legalDepositsPeriodicalLibrariesIdVolumesPrevious = function (plId) { return "legal-deposits/periodical-libraries/".concat(plId, "/volumes/previous"); };
export var legalDepositsPeriodicalLibrariesIdVolumesIdDepositRecords = function (plId, volumeId) {
    return "legal-deposits/periodical-libraries/".concat(plId, "/volumes/").concat(volumeId, "/deposit-records");
};
export var legalDepositsPeriodicalVolumesId = function (volumeId) {
    return "legal-deposits/periodical-volumes/".concat(volumeId);
};
export var legalDepositsPeriodicalVolumesIdWindowPreview = function (volumeId) { return "legal-deposits/periodical-volumes/".concat(volumeId, "/window-preview"); };
export var legalDepositsPeriodicalIssuesIdLibraryStatus = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/library-status");
};
export var legalDepositsPeriodicalIssuesId = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId);
};
export var legalDepositsPeriodicalLibrariesIdSpecialIssues = function (plId) {
    return "legal-deposits/periodical-libraries/".concat(plId, "/special-issues");
};
export var legalDepositsPeriodicalLibrariesIdIrregularIssues = function (plId) { return "legal-deposits/periodical-libraries/".concat(plId, "/irregular-issues"); };
export var legalDepositsPeriodicalLibrariesIdRegularIssues = function (plId) {
    return "legal-deposits/periodical-libraries/".concat(plId, "/regular-issues");
};
export var legalDepositsPeriodicalsIdEndPublication = function (titleId) {
    return "legal-deposits/periodicals/".concat(titleId, "/end-publication");
};
export var legalDepositsPeriodicalsIdReopenPublication = function (titleId) {
    return "legal-deposits/periodicals/".concat(titleId, "/reopen-publication");
};
export var legalDepositsCrossLibraryByTitle = function (titleId) {
    return "legal-deposits/cross-library/by-title/".concat(titleId);
};
export var legalDepositsTitlesIdLibraryNotesMy = function (titleId) {
    return "legal-deposits/titles/".concat(titleId, "/library-notes/my");
};
export var legalDepositsTitlesIdLibraryNotesDialog = function (titleId) {
    return "legal-deposits/titles/".concat(titleId, "/library-notes/dialog");
};
export var legalDepositsPeriodicalIssuesMerge = "legal-deposits/periodical-issues/merge";
export var legalDepositsPeriodicalIssuesIdUnmerge = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/unmerge");
};
export var legalDepositsPeriodicalIssuesIdLabel = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/label");
};
export var legalDepositsPeriodicalIssuesIdLabelReset = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/label/reset");
};
export var legalDepositsTitlesIdSchedulePreview = function (titleId) {
    return "legal-deposits/titles/".concat(titleId, "/schedule/preview");
};
export var legalDepositsTitlesIdSchedule = function (titleId) {
    return "legal-deposits/titles/".concat(titleId, "/schedule");
};
/**
 * Path: /legal-deposits/libraries/{libraryId}/message-templates
 * GET: No description
 * Response: LibraryMessageTemplatesResponse
 */
export var legalDepositsLibrariesIdMessageTemplates = function (libraryId) {
    return "legal-deposits/libraries/".concat(libraryId, "/message-templates");
};
/**
 * Path: /legal-deposits/libraries/{libraryId}/message-templates/{type}
 * PUT: No description
 * Request: MessageTemplateUpsertRequest
 * Response: MessageTemplateDto
 * DELETE: No description
 * Response: void
 */
export var legalDepositsLibrariesIdMessageTemplatesType = function (libraryId, type) { return "legal-deposits/libraries/".concat(libraryId, "/message-templates/").concat(type); };
/**
 * Path: /legal-deposits/libraries/{libraryId}/message-templates/preview
 * POST: No description
 * Request: MessageTemplatePreviewRequest
 * Response: MessageTemplatePreviewResponse
 */
export var legalDepositsLibrariesIdMessageTemplatesPreview = function (libraryId) { return "legal-deposits/libraries/".concat(libraryId, "/message-templates/preview"); };
/**
 * Path: /legal-deposits/libraries/{id}/referent-signature
 * PUT: No description
 * Request: ReferentSignatureRequest
 * Response: void
 */
export var legalDepositsLibrariesIdReferentSignature = function (id) {
    return "legal-deposits/libraries/".concat(id, "/referent-signature");
};
export var reportsDownloadFileId = function (fileId) {
    return "legal-deposits/reports/download/".concat(fileId);
};
export var legalDepositsTitlesIdMerges = function (id) {
    return "legal-deposits/titles/".concat(id, "/merges");
};
export var legalDepositsTitlesIdDuplicateGroups = function (id) {
    return "legal-deposits/titles/".concat(id, "/duplicate-groups");
};
export var legalDepositsTitlesDuplicateReviewId = function (reviewId) {
    return "legal-deposits/titles/duplicate-reviews/".concat(reviewId);
};
export var legalDepositsTitlesIdAgencyNotifications = function (id) {
    return "legal-deposits/titles/".concat(id, "/agency-notifications");
};
export var legalDepositsTitlesIdAgencyNotificationsIdResend = function (id, notificationId) {
    return "legal-deposits/titles/".concat(id, "/agency-notifications/").concat(notificationId, "/resend");
};
export var legalDepositsTitlesIdAgenda = function (id) {
    return "legal-deposits/titles/".concat(id, "/agenda");
};
export var legalDepositsTitlesIdAgendaHistory = function (id) {
    return "legal-deposits/titles/".concat(id, "/agenda/history");
};
export var legalDepositsTitlesIdGlobalType = function (id) {
    return "legal-deposits/titles/".concat(id, "/global-type");
};
export var legalDepositsPeriodicalIssuesIdAgenda = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/agenda");
};
export var legalDepositsPeriodicalIssuesIdMonographLink = function (issueId) {
    return "legal-deposits/periodical-issues/".concat(issueId, "/monograph-link");
};
export var legalDepositsPeriodicalIssuesIdLinkMembership = function (issueId) { return "legal-deposits/periodical-issues/".concat(issueId, "/link-membership"); };
export var legalDepositsTitlesIdSpecialIssueLink = function (id) {
    return "legal-deposits/titles/".concat(id, "/special-issue-link");
};
export var legalDepositsSpecialIssueLinksPeriodicals = "legal-deposits/special-issue-links/periodicals";
export var legalDepositsSpecialIssueLinksPeriodicalsIdVolumes = function (periodicalTitleId) {
    return "legal-deposits/special-issue-links/periodicals/".concat(periodicalTitleId, "/volumes");
};
export var legalDepositsSpecialIssueLinksPeriodicalsIdIssues = function (periodicalTitleId) {
    return "legal-deposits/special-issue-links/periodicals/".concat(periodicalTitleId, "/issues");
};
